import * as React from "react";
const ClosedBusiness = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <rect width={32} height={32} fill="#fff" fillOpacity={0.08} rx={16} />
    <mask
      id="aClosedBusiness"
      width={20}
      height={20}
      x={6}
      y={6}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M6 6h20v20H6z" />
    </mask>
    <g mask="url(#aClosedBusiness)">
      <path
        fill="#F1F5F9"
        d="M9.334 23.5c-.459 0-.851-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.177v-9.166c0-.459.163-.851.49-1.178.326-.326.718-.489 1.177-.489h3.333V9.333c0-.458.163-.85.49-1.177.326-.326.718-.49 1.177-.49h3.333c.458 0 .85.164 1.177.49.326.327.49.719.49 1.177V11h3.333c.458 0 .85.163 1.177.49.326.326.49.718.49 1.177v9.166c0 .459-.163.851-.49 1.177-.326.327-.719.49-1.177.49H9.334Zm5-12.5h3.333V9.333h-3.333V11Zm8.333 7.5H18.5v1.667h-5V18.5H9.334v3.333h13.333V18.5Zm-7.5 0h1.667v-1.667h-1.667V18.5Zm-5.833-1.667H13.5v-1.666h5v1.666h4.167v-4.166H9.334v4.166Z"
      />
    </g>
  </svg>
);
export default ClosedBusiness;
